import React, { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { OfferFormValues } from "../../../schemas/offerFormSchema";
import { MantineDateRangePicker } from "@/components/ui/date-range-picker/MantineDateRangePicker";
import { MantineProvider } from "@/components/ui/date-range-picker/MantineProvider";
import { ensureValidDateRange } from "@/components/ui/date-range-picker/utils/datePickerUtils";

interface DateRangeSectionProps {
  form: UseFormReturn<OfferFormValues>;
  markFieldAsModified?: (fieldName: string) => void;
}

export const DateRangeSection: React.FC<DateRangeSectionProps> = ({
  form,
  markFieldAsModified = () => {}
}) => {
  // Ensure that the form has valid date values before rendering the picker
  useEffect(() => {
    const currentStartDate = form.getValues("startDate");
    const currentEndDate = form.getValues("endDate");
    
    
    // CRITICAL FIX: Only update if dates are ACTUALLY invalid
    // Don't normalize valid dates that might be from database
    let needsUpdate = false;
    let validStartDate = currentStartDate;
    let validEndDate = currentEndDate;
    
    // Only fix start date if it's actually invalid
    if (!currentStartDate || !(currentStartDate instanceof Date) || isNaN(currentStartDate.getTime())) {
      validStartDate = new Date();
      needsUpdate = true;
    }
    
    // Only fix end date if it's actually invalid
    if (!currentEndDate || !(currentEndDate instanceof Date) || isNaN(currentEndDate.getTime())) {
      validEndDate = validStartDate; // Use start date as fallback
      needsUpdate = true;
    }
    
    // Only swap if end is before start AND both dates are valid
    if (validStartDate && validEndDate && validEndDate < validStartDate) {
      const temp = validStartDate;
      validStartDate = validEndDate;
      validEndDate = temp;
      needsUpdate = true;
    }
    
    // Only update form if we actually need to fix something
    if (needsUpdate) {
      
      form.setValue("startDate", validStartDate, {
        shouldValidate: true
      });
      
      form.setValue("endDate", validEndDate, {
        shouldValidate: true
      });
    }
  }, [form]);
  
  return (
    <div className="space-y-4 col-span-full">
      <MantineProvider>
        <MantineDateRangePicker 
          form={form} 
          startDateName="startDate" 
          endDateName="endDate" 
          startDateLabel="Start date" 
          endDateLabel="End date" 
          onDateChange={markFieldAsModified} 
        />
      </MantineProvider>
    </div>
  );
};
